import { Link } from "react-router-dom";
import { BookOpen, Sparkles, Heart, ShieldCheck, Users, Globe } from "lucide-react";

export default function About() {
  return (
    <div className="bg-[#fafaf9] min-h-screen" data-testid="about-page">
      {/* HERO */}
      <section className="bg-[#09090b] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)", backgroundSize: "24px 24px" }} />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 relative">
          <div className="inline-flex items-center gap-2 border border-[#ea580c]/40 bg-[#ea580c]/10 text-[#fb923c] px-3 py-1.5 text-xs font-bold tracking-[0.2em] uppercase mb-6">
            <Sparkles className="w-3.5 h-3.5" /> About Us
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[0.95]" data-testid="about-title">
            Great books create<br />
            <span className="text-[#fb923c]">great minds.</span>
          </h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 space-y-8 text-[#3f3f46] text-base md:text-lg leading-relaxed">
        <p>
          At <strong className="text-[#09090b]">GAINA THE PRELUDE</strong>, we believe great books create great minds. We're more than a bookstore — we're a destination for readers, dreamers, and lifelong learners.
        </p>
        <p>
          Our carefully curated collection brings together bestselling titles, timeless classics, educational resources, and hidden gems, making it easy for every reader to discover their next favorite book.
        </p>
        <p>
          Driven by a passion for stories and knowledge, we're committed to delivering quality, affordability, and an exceptional shopping experience. Every book on our shelves is chosen to inspire curiosity, fuel imagination, and empower growth.
        </p>
        <p>
          With a commitment to quality, authenticity, and exceptional service, GAINA THE PRELUDE has become a trusted destination for book lovers. Whether you're searching for your next favorite read or building your personal library, we're here to make every reading journey unforgettable.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 grid grid-cols-1 md:grid-cols-3 gap-5">
        {[
          { icon: Heart, title: "Passion First", body: "Every title curated by book-lovers, not algorithms." },
          { icon: ShieldCheck, title: "Trusted Quality", body: "Authentic editions with hassle-free replacement on damage." },
          { icon: Globe, title: "Worldwide Reach", body: "Delivering India's finest publications to readers globally." },
        ].map(({ icon: Icon, title, body }) => (
          <div key={title} className="bg-white border border-[#e7e5e4] p-6">
            <Icon className="w-8 h-8 text-[#ea580c]" strokeWidth={2.2} />
            <div className="mt-4 font-display font-black text-lg text-[#09090b]">{title}</div>
            <p className="mt-2 text-sm text-[#57534e]">{body}</p>
          </div>
        ))}
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 flex flex-wrap gap-6 justify-center items-center text-sm">
        <Link to="/books" className="inline-flex items-center gap-2 border-b-2 border-[#09090b] text-[#09090b] font-bold tracking-wide uppercase pb-1 hover:text-[#ea580c] hover:border-[#ea580c] transition-colors">Browse Books →</Link>
        <Link to="/values" className="inline-flex items-center gap-2 border-b-2 border-[#09090b] text-[#09090b] font-bold tracking-wide uppercase pb-1 hover:text-[#ea580c] hover:border-[#ea580c] transition-colors">Our Values →</Link>
      </section>
    </div>
  );
}
